import './Router.css';
import PropTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';

/**
 * Componente que renderiza as rotas com classes CSS para transições
 * @param {Object} props - Props do componente
 * @param {Array<Object>} props.routes - Array de rotas com { path: string, element: JSX.Element }
 * @param {Object} props.displayLocation - Location do react-router a ser exibido
 * @param {string} props.transitionStage - Estágio da transição: "fadeIn" | "exitingOld" | "enteringNew"
 * @param {boolean} props.contentFadeOut - Se deve aplicar fadeOut no conteúdo
 * @param {boolean} props.contentDelay - Se deve aplicar delay antes de aparecer
 * @param {boolean} props.fromLoading - Se está vindo de um estado de loading
 * @returns {JSX.Element}
 */
const Router = ({
  routes,
  displayLocation,
  transitionStage,
  contentFadeOut,
  contentDelay,
  fromLoading,
}) => {
  const classNames = [
    'page-transition',
    // Não aplica transitionStage se fromLoading estiver ativo (prioridade para animação from-loading)
    fromLoading ? '' : transitionStage,
    contentFadeOut ? 'content-fade-out' : '',
    contentDelay ? 'content-delayed' : '',
    fromLoading ? 'from-loading' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classNames}>
      <Routes location={displayLocation}>
        {routes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
      </Routes>
    </div>
  );
};

Router.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      element: PropTypes.element.isRequired,
    }),
  ).isRequired,
  displayLocation: PropTypes.object.isRequired,
  transitionStage: PropTypes.string.isRequired,
  contentFadeOut: PropTypes.bool.isRequired,
  contentDelay: PropTypes.bool.isRequired,
  fromLoading: PropTypes.bool.isRequired,
};

export default Router;
